export enum UserRole {
  ConsiliumAdmin = "ConsiliumAdmin",
  ConsiliumEmployee = "ConsiliumEmployee",
  OEM = "Oem",
  Customer = "Customer",
}
